import { api } from "@/api";
import {
  invalidateStorageQueries,
  type StorageBooking,
  type StorageBookingInput,
} from "./storage";

/** Issues a PIN if the customer has none and texts the welcome message. */
export const createStorageBooking = async (input: StorageBookingInput) => {
  const { body } = await api.post<StorageBooking>("/storage/bookings", {
    body: input,
  });
  invalidateStorageQueries();
  return body;
};
